import { useEffect, useLayoutEffect, useState } from 'react';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export const useElementHeight = (targetElementIds?: string[]) => {
  const [elementHeight, setElementHeight] = useState(0);

  useIsomorphicLayoutEffect(() => {
    const ids = targetElementIds || [];
    const elements = ids.map((id) => document.getElementById(id)).filter(Boolean) as HTMLElement[];

    const calculateHeight = () => {
      const total = elements.reduce((acc, el) => acc + el.clientHeight, 0);
      setElementHeight(total);
    };

    // Initial calculation
    calculateHeight();

    if (elements.length === 0) return;

    // Watch for element size changes
    const observer = new ResizeObserver(calculateHeight);
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [targetElementIds]);

  useEffect(() => {
    const ids = targetElementIds || [];
    const elements = ids.map((id) => document.getElementById(id)).filter(Boolean) as HTMLElement[];

    const handleResize = () => {
      const total = elements.reduce((acc, el) => acc + el.clientHeight, 0);
      setElementHeight(total);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [targetElementIds]);

  return elementHeight;
};
